import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class MetricDetailsExploreModulesDataVisualizationToolbarAnomalyDetectionPopupErrorComponent extends PopupInnerContextComponent<PopupData.Anomaly.Error> {
	get anomalyStatusObjectInErrorOrInfo() {
		return this.popupData.anomalyStatusObjectInErrorOrInfo;
	}

	get showRetryButton() {
		return this.anomalyStatusObjectInErrorOrInfo?.isError;
	}

	@action
	onRetry() {
		this.popupData.onRetryClick();
	}
	<template>
		<span class="attention-icon">
			<CommonUiIconComponent @name="AlertFill" @size="md" />
		</span>

		<div class="body">
			<h5>Data anomalies are currently unavailable</h5>

			<p>{{this.anomalyStatusObjectInErrorOrInfo.title}}</p>

			{{#if this.showRetryButton}}
				<SubmitButtonComponent
					@text="Retry"
					@noDelay={{true}}
					@onTrigger={{this.onRetry}}
					@size="small"
				/>
			{{/if}}
		</div>
	</template>
}
